(() => {
  function mount() {
    document.querySelectorAll('.product__info-container').forEach(root => {
      if (root.dataset.amReady) return;
      root.dataset.amReady = 'true';
      const picker = root.querySelector('variant-radios, variant-selects');
      const size = root.querySelector('[data-am-ring-size]');
      if (size && new URLSearchParams(location.search).get('am_restore_size') === '1') size.value = size.dataset.amSelectedSize || '';
      const form = root.querySelector('form[data-type="add-to-cart-form"]');
      const guide = root.querySelector('[data-am-size-dialog]');
      if (guide && typeof guide.showModal === 'function') {
        let opener;
        root.querySelectorAll('a[href$="/pages/maattabel"]').forEach(link => {
          if (guide.contains(link)) return;
          link.setAttribute('role', 'button');
          link.setAttribute('aria-haspopup', 'dialog');
          link.setAttribute('aria-controls', guide.id);
          const open = event => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            opener = link;
            guide.returnValue = '';
            guide.showModal();
          };
          link.addEventListener('click', open);
          link.addEventListener('keydown', event => {
            if (event.key === ' ') open(event);
          });
        });
        guide.querySelector('[data-am-size-close]').addEventListener('click', () => guide.close());
        guide.querySelector('[data-am-size-continue]').addEventListener('click', () => guide.close('choose'));
        guide.addEventListener('close', () => {
          const target = guide.returnValue === 'choose' ? size : opener;
          if (target?.isConnected) target.focus({preventScroll: true});
        });
      }
      root.querySelectorAll('[data-am-band-dialog]').forEach(dialog => {
        if (typeof dialog.showModal !== 'function') return;
        const opener = root.querySelector(`[data-am-band-open="${dialog.id}"]`);
        if (!opener) return;
        opener.setAttribute('role', 'button');
        opener.setAttribute('aria-haspopup', 'dialog');
        opener.setAttribute('aria-controls', dialog.id);
        const open = event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          dialog.querySelectorAll('[data-am-band-value]').forEach(button => {
            const field = picker?.querySelector(`[data-am-option-position="${button.dataset.amBandPosition}"]`);
            const control = field?.querySelector('select, input:checked');
            button.setAttribute('aria-pressed', String(control?.value === button.dataset.amBandValue));
          });
          dialog.showModal();
        };
        opener.addEventListener('click', open);
        opener.addEventListener('keydown', event => { if (event.key === ' ') open(event); });
        dialog.querySelectorAll('[data-am-band-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
        dialog.querySelectorAll('[data-am-band-value]').forEach(button => button.addEventListener('click', () => {
          const field = picker?.querySelector(`[data-am-option-position="${button.dataset.amBandPosition}"]`);
          const select = field?.querySelector('select');
          const radio = Array.from(field?.querySelectorAll('input[type="radio"]') || []).find(input => input.value === button.dataset.amBandValue);
          if (select) {
            if (!Array.from(select.options).some(option => option.value === button.dataset.amBandValue)) return;
            select.value = button.dataset.amBandValue;
          } else if (radio) radio.checked = true;
          else return;
          (select || radio).dispatchEvent(new Event('change', {bubbles:true}));
          dialog.close();
        }));
        dialog.addEventListener('close', () => opener.focus({preventScroll:true}));
      });
      if (size && form) {
        form.addEventListener('submit', event => {
          if (size.value) return;
          event.preventDefault(); event.stopImmediatePropagation();
          size.focus(); size.reportValidity();
        }, true);
        if (size.value && picker && new URLSearchParams(location.search).get('am_restore_size') === '1') {
          picker.updateOptions(); picker.updateMasterId();
          if (picker.currentVariant) {
            picker.updateVariantInput();
            picker.toggleAddButton(!picker.currentVariant.available, window.variantStrings.soldOut);
          }
        }
      }
      // Easify manages plate count, shape and lettering. The native base stays without a plate.
      if (picker && root.querySelector('input[name="Graveerplaatje"][value="Geen"][checked]')) {
        picker.updateOptions(); picker.updateMasterId();
        if (picker.currentVariant) picker.updateVariantInput();
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once:true}); else mount();
  document.addEventListener('shopify:section:load', mount);
})();

